import { render, staticRenderFns } from "./riskTab.vue?vue&type=template&id=b1b277fe"
import script from "./riskTab.vue?vue&type=script&lang=js"
export * from "./riskTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1b277fe')) {
      api.createRecord('b1b277fe', component.options)
    } else {
      api.reload('b1b277fe', component.options)
    }
    module.hot.accept("./riskTab.vue?vue&type=template&id=b1b277fe", function () {
      api.rerender('b1b277fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/riskTab.vue"
export default component.exports